import { BANK_DETAILS } from '@/core/field-names';
import { BankDetailFieldErrors } from '@/core/validation/field-errors';

export async function validateBankDetailsCommonFields(field) {
  switch (field.name) {
    case BANK_DETAILS.ACCOUNT_NAME:
      if (!field.value) {
        return BankDetailFieldErrors.EmptyAccountName;
      }
      break;
    case BANK_DETAILS.ACCOUNT_NUMBER:
      if (!field.value) {
        return BankDetailFieldErrors.EmptyAccountNumber;
      }
      break;
  }

  return '';
}
